import { render, staticRenderFns } from "./part-app-link.vue?vue&type=template&id=4372af3f"
import script from "./part-app-link.vue?vue&type=script&lang=js"
export * from "./part-app-link.vue?vue&type=script&lang=js"
import style0 from "./part-app-link.vue?vue&type=style&index=0&id=4372af3f&prod&module=true&lang=css"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports